export const formatHexColor = (value) => {
  if (value == null || value === "") return null;
  return value.startsWith("#") ? value : `#${value}`;
};

export const stripHexColor = (value) => {
  if (value == null || value === "") return null;
  return value.replace("#", "");
};

export const resolveFallbackColors = (user, themeProps, themeMode) => ({
  theme_color_light:
    formatHexColor(user?.theme_color_light) ||
    formatHexColor(user?.ui_settings?.theme_color_light) ||
    themeProps.primary.light,
  theme_color_main:
    formatHexColor(user?.theme_color_main) ||
    formatHexColor(user?.ui_settings?.theme_color_main) ||
    themeProps.primary.main,
  theme_color_dark:
    formatHexColor(user?.theme_color_dark) ||
    formatHexColor(user?.ui_settings?.theme_color_dark) ||
    themeProps.primary.dark,
  theme_mode:
    user?.theme_mode ??
    user?.ui_settings?.theme_mode ??
    themeMode ??
    true
});

export const isTenantBrandingThemeSource = (source) => {
  if (!source || typeof source !== "object" || Array.isArray(source)) return false;
  return Boolean(source.theme_color_main || source.theme_color_light || source.theme_color_dark);
};

// Prefer org/tenant branding over a tenant_user personal theme. Order matters:
// tenant settings (in-app) → organization record → document-link theme payload.
// theme_mode is taken from the first source that actually sets it — never defaulted
// to light, so a dark ambient theme is not forced to a light background.
export const resolveTenantBrandingTheme = (...sources) => {
  let colors = null;
  let themeMode;

  for (const source of sources) {
    if (!source || typeof source !== "object" || Array.isArray(source)) continue;
    if (!colors && isTenantBrandingThemeSource(source)) {
      colors = {
        theme_color_light: source.theme_color_light,
        theme_color_main: source.theme_color_main,
        theme_color_dark: source.theme_color_dark
      };
    }
    if (themeMode === undefined && source.theme_mode !== null && source.theme_mode !== undefined) {
      themeMode = source.theme_mode;
    }
  }

  if (!colors) return null;
  return {
    ...colors,
    ...(themeMode !== undefined ? { theme_mode: themeMode } : {})
  };
};

export const buildDocumentThemePalette = (documentTheme, fallbackThemeProps) => ({
  primary: {
    light:
      formatHexColor(documentTheme?.theme_color_light) ||
      fallbackThemeProps?.primary?.light,
    main:
      formatHexColor(documentTheme?.theme_color_main) ||
      fallbackThemeProps?.primary?.main,
    dark:
      formatHexColor(documentTheme?.theme_color_dark) ||
      fallbackThemeProps?.primary?.dark,
    contrastText: "#fff"
  }
});

export const applyDocumentThemeToLayout = (layoutItems, documentTheme) => {
  if (!documentTheme || !layoutItems?.length) {
    return layoutItems || [];
  }

  const headerColor = formatHexColor(documentTheme.theme_color_main);
  if (!headerColor) {
    return layoutItems;
  }

  return layoutItems.map((item) => {
    if (item.typeId !== "product_service" || !item.settings) {
      return item;
    }

    return {
      ...item,
      settings: {
        ...item.settings,
        headerColor
      }
    };
  });
};

export const resolveFallbackThemeMode = (user, themeMode) => {
  if (user?.theme_mode !== null && user?.theme_mode !== undefined) {
    return user.theme_mode;
  }
  if (user?.ui_settings?.theme_mode !== null && user?.ui_settings?.theme_mode !== undefined) {
    return user.ui_settings.theme_mode;
  }
  return themeMode;
};
